/**
 * Phonics Letter Pp — 课程数据配置
 *
 * 媒体资源基础路径（对应服务器 /media/phonics/pp/）
 *
 * Step 1: Song/Chant — pp.mp4, 00:11~01:35
 * Step 2: 4格单词 — pig/pizza/piano/puppy
 * Step 3: Learn the Story (1) — pp(1).mp4, pizza 故事
 * Step 4: Learn the Story (2) — pp(2).mp4, piano 故事（PPT P9 拆分）
 * Step 5: Learn the Story (3) — pp(3).mp4, puppy 故事（PPT P9 拆分）
 */

const MEDIA_BASE = '/media/phonics/pp';
const V = 'v1';

export const letterDataPp = {
  letter: 'Pp',
  title: 'Phonics',
  subtitle: 'Letter Pp',

  mediaBase: MEDIA_BASE,

  // Step 1: 歌曲视频片段
  songVideo: {
    src: `${MEDIA_BASE}/Pp.mp4?${V}`,
    poster: `${MEDIA_BASE}/Pp.png?${V}`,
    startTime: 11,
    endTime: 95,
  },

  // Step 2: 4 格单词视频
  wordVideos: [
    { id: 1, src: `${MEDIA_BASE}/video_s3_word1.mp4?${V}`, cover: `${MEDIA_BASE}/image8.png?${V}` },
    { id: 2, src: `${MEDIA_BASE}/video_s3_word2.mp4?${V}`, cover: `${MEDIA_BASE}/image9.png?${V}` },
    { id: 3, src: `${MEDIA_BASE}/video_s3_word3.mp4?${V}`, cover: `${MEDIA_BASE}/image10.png?${V}` },
    { id: 4, src: `${MEDIA_BASE}/video_s3_word4.mp4?${V}`, cover: `${MEDIA_BASE}/image11.png?${V}` },
  ],

  // 统一 storySections
  storySections: [

    // Learn the Story (1) — pizza 故事
    {
      label: 'Learn the Story (1)',
      layout: 'video-top-lines-bottom',
      videos: [{ src: `${MEDIA_BASE}/video_story_pizza.mp4?${V}`, poster: `${MEDIA_BASE}/image13.png?${V}` }],
      lines: [
        { en: 'Pig, what do you want?', cn: '猪，你想要什么？', audioEn: `${MEDIA_BASE}/story1_en_1.mp3?${V}`, audioCn: `${MEDIA_BASE}/story1_cn_1.mp3?${V}` },
        { en: 'I want pizza.', cn: '我想要披萨。', audioEn: `${MEDIA_BASE}/story1_en_2.mp3?${V}`, audioCn: `${MEDIA_BASE}/story1_cn_2.mp3?${V}` },
        { en: 'Here is your pizza.', cn: '这是你的披萨。', audioEn: `${MEDIA_BASE}/story1_en_3.mp3?${V}`, audioCn: `${MEDIA_BASE}/story1_cn_3.mp3?${V}` },
      ],
    },

    // Learn the Story (2) — piano 故事（PPT P9 上半部分）
    {
      label: 'Learn the Story (2)',
      layout: 'video-top-lines-bottom',
      videos: [{ src: `${MEDIA_BASE}/video_story_piano.mp4?${V}`, poster: `${MEDIA_BASE}/image14.png?${V}` }],
      lines: [
        { en: 'Pig, what do you want?', cn: '猪，你想要什么？', audioEn: `${MEDIA_BASE}/story2_en_1.mp3?${V}`, audioCn: `${MEDIA_BASE}/story2_cn_1.mp3?${V}` },
        { en: 'I want a piano.', cn: '我想要钢琴。', audioEn: `${MEDIA_BASE}/story2_en_2.mp3?${V}`, audioCn: `${MEDIA_BASE}/story2_cn_2.mp3?${V}` },
        { en: 'Here is your piano.', cn: '这是你的钢琴。', audioEn: `${MEDIA_BASE}/story2_en_3.mp3?${V}`, audioCn: `${MEDIA_BASE}/story2_cn_3.mp3?${V}` },
      ],
    },

    // Learn the Story (3) — puppy 故事（PPT P9 下半部分）
    {
      label: 'Learn the Story (3)',
      layout: 'video-top-lines-bottom',
      videos: [{ src: `${MEDIA_BASE}/video_story_puppy.mp4?${V}`, poster: `${MEDIA_BASE}/image15.png?${V}` }],
      lines: [
        { en: 'Pig, what do you want?', cn: '猪，你想要什么？', audioEn: `${MEDIA_BASE}/story3_en_1.mp3?${V}`, audioCn: `${MEDIA_BASE}/story3_cn_1.mp3?${V}` },
        { en: 'I want a puppy.', cn: '我想要小狗。', audioEn: `${MEDIA_BASE}/story3_en_2.mp3?${V}`, audioCn: `${MEDIA_BASE}/story3_cn_2.mp3?${V}` },
        { en: 'Here is your puppy.', cn: '这是你的小狗。', audioEn: `${MEDIA_BASE}/story3_en_3.mp3?${V}`, audioCn: `${MEDIA_BASE}/story3_cn_3.mp3?${V}` },
      ],
    },

  ],

  // 封面背景图
  coverBg: `${MEDIA_BASE}/image1.jpeg`,

  // 视频封面图（来自 AtoZ_cover/Pp.png）
  coverPoster: `${MEDIA_BASE}/Pp.png?${V}`,
};

export default letterDataPp;
